import { Reveal } from "./motion";
import { InViewTextEffect } from "@/components/ui/text-effect";

const ROWS = [
  { them: "Locked pre-built sections — toggle on/off only, no rearranging", us: "Full custom code — every pixel is actually yours to change" },
  { them: "One global font-size slider changes every heading site-wide", us: "Real design control, section by section" },
  { them: "No access to robots.txt, sitemaps, or schema markup", us: "Real SEO — sitemap, meta tags, Core Web Vitals tuning" },
  { them: "Renewal prices jump 50-70% after year one", us: "Flat, stated maintenance pricing — no renewal shock" },
  { them: "A chatbot, and a support queue with ~12 min average wait", us: "One person who knows your business, same-day fixes" },
  ];

export default function Differentiator() {
    return (
          <section
                  id="differentiator"
                  className="relative z-10 overflow-hidden border-t border-hairline px-5 py-24 md:px-8 md:py-32"
                  data-testid="differentiator-section"
                >
                <div className="mx-auto max-w-5xl">
                        <InViewTextEffect
                                  as="p"
                                  preset="blur"
                                  className="font-mono text-[11px] uppercase tracking-[0.24em] text-rust"
                                >
                                  CH.05 // The Honest Comparison
                        </InViewTextEffect>
                        <Reveal
                                    as="h2"
                                    delay={0.05}
                                    className="mt-5 max-w-2xl font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ink md:text-5xl"
                                  >
                                  Why not just build it yourself for <em className="italic text-pine">$30?</em>
                        </Reveal>
                
                        <Reveal delay={0.14} className="mt-10 overflow-hidden rounded-lg border border-hairline">
                                  <div className="grid grid-cols-2 bg-panel/60 font-mono text-[10px] uppercase tracking-[0.18em] text-ink-dim">
                                              <div className="px-5 py-3 border-r border-hairline">$30/mo template builder</div>
                                              <div className="px-5 py-3 text-pine">Zigler Designs</div>
                                  </div>
                          {ROWS.map((r, i) => (
                              <div
                                              key={i}
                                              className={`grid grid-cols-2 ${i !== 0 ? "border-t border-hairline" : ""}`}
                                            >
                                            <div className="px-5 py-4 border-r border-hairline text-[13px] leading-relaxed text-ink-dim">
                                              {r.them}
                                            </div>
                                            <div className="px-5 py-4 text-[13px] leading-relaxed text-ink">
                                              {r.us}
                                            </div>
                              </div>
                            ))}
                        </Reveal>
                
                        <Reveal
                                    delay={0.22}
                                    className="mt-10 max-w-2xl border-l-2 border-pine pl-6 font-serif text-xl italic leading-relaxed text-ink md:text-2xl"
                                  >
                                  "For $30/month you get a locked template and a chatbot. For a
                                  comparable price on a Starter build plus maintenance, you get a
                                  real site with no ceiling, and an actual person who fixes things
                                  the same day they break."
                        </Reveal>
                </div>
          </section>
        );
}
